import { render, staticRenderFns } from "./AdminClubArticleInfo.vue?vue&type=template&id=01db4a5b&scoped=true&"
import script from "./AdminClubArticleInfo.vue?vue&type=script&lang=js&"
export * from "./AdminClubArticleInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminClubArticleInfo.vue?vue&type=style&index=0&id=01db4a5b&lang=less&scoped=true&"
import style1 from "./AdminClubArticleInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01db4a5b",
  null
  
)

export default component.exports